/** Landing route for the New UI. Operating View, not the Guide — the New UI's
 *  default view moved after the Old/New toggle was first written. */
export const NEW_UI_HOME = "/dashboard-insight";
